// extracted by mini-css-extract-plugin
module.exports = {"NoActiveOrders":"Orders_NoActiveOrders__34KHj"};